import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=6e18bc54&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__